import { render } from "./anchors.vue?vue&type=template&id=67514eb2"
import script from "./anchors.vue?vue&type=script&lang=js"
export * from "./anchors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__